import { combineEpics } from 'redux-observable';
import { updateDataSourceEpicReducer } from '../ducks/DataSourceUpdate.ducks';
export default combineEpics(updateDataSourceEpicReducer.epic);

//# sourceMappingURL=DataSourceUpdateEpic.js.map
